module.exports = __webpack_public_path__ + "img/avatar.3b9a5201.jpg";